import { ORG_FILTER_GROUPS } from '@/utils/organizations';

/**
 * OrganizationFilter — MVP filtr rodowodu (pill group).
 * 4 opcje: Wszystkie / FCI / ZKwP / Inne / Bez rodowodu.
 *
 * Props:
 *  - value: string key ('all' | 'fci' | 'other' | 'no_pedigree')
 *  - onChange: (key) => void
 *  - className: string
 *  - compact: bool (mniejszy padding dla wąskich sidebarów)
 */
export default function OrganizationFilter({ value = 'all', onChange, className = '', compact = false }) {
  const padCls = compact ? 'px-3 py-1.5 text-xs' : 'px-4 py-2 text-sm';

  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`} data-testid="organization-filter">
      <span className="text-xs text-gray-500 mr-1">Rodowód:</span>
      {ORG_FILTER_GROUPS.map(group => {
        const active = value === group.key;
        const colorCls = (() => {
          if (!active) return 'bg-white/5 border-white/10 text-gray-400 hover:bg-white/10 hover:text-white';
          if (group.key === 'fci') return 'bg-emerald-500/20 border-emerald-500/50 text-emerald-300';
          if (group.key === 'other') return 'bg-blue-500/20 border-blue-500/50 text-blue-300';
          if (group.key === 'no_pedigree') return 'bg-gray-500/20 border-gray-500/50 text-gray-300';
          return 'bg-white/10 border-white/20 text-white';
        })();
        return (
          <button
            type="button"
            key={group.key}
            onClick={() => onChange?.(group.key)}
            data-testid={`org-filter-${group.key}`}
            aria-pressed={active}
            className={`${padCls} rounded-full border font-medium transition-colors ${colorCls}`}
          >
            {group.label}
          </button>
        );
      })}
    </div>
  );
}
